'use client';

import { BannerAdSlot } from '@/app/_components/ads';
import { AD_PLACEMENTS } from '@/app/_components/ads/adPlacements';

export const HospitalDetailBannerAd = () => (
  <BannerAdSlot
    {...AD_PLACEMENTS.contentDetailBottom}
    wrapperClassName="flex justify-center p-20"
  />
);
